<template>
  <div class="box box-pack-between main">
    <sort-label-show
      title=""
      :list="treeList"
      titleName="资源分类"
      @nodeClick="getNodeIds"
      @handleDragEnd="handleDragEnd"
      @createTag="createTagEvent"
      @delLabel="delLabel"
      ref="sortLabel"
    ></sort-label-show>
    <div class="flex1">
      <div class="whiteBg height100 main-right">
        <dy-table
          :columns="columns"
          :table-data="tableData"
          ref="table"
          v-loading="tableLoading"
          :total="total"
          :page-num="currentPage"
          :page-size="10"
          @current-change="onCurrentChange"
          element-loading-text="加载中"
        ></dy-table>
      </div>
    </div>
  </div>
</template>
<script>
import DyTable from '@/components/common/dytable';
import sortLabelShow from '@/components/common/sortLabelShow/questionIndex';
import { formatDate } from '@/utils/utils';
import { zgsourceAllCategory, listQuestion, zgDeleteCategory, selectListResource, zgAddCategory } from '@/api/index';
import { encrypt, decrypt } from '@/api/common_encrypt';

var that = null;
export default {
  data() {
    return {
      tableLoading: true,
      columns: [
        {
          key: 'textName',
          title: '资源名称',
        },
        {
          key: 'bgUserName',
          title: '操作人',
        },
        {
          key: 'updateDate',
          title: '最后更新时间',
        },
      ],
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      treeList: [],
      sortVal: '1',
      options: [
        {
          value: '1',
          label: '资源',
        },
        {
          value: '2',
          label: '题库',
        },
      ],
    };
  },
  components: {
    sortLabelShow,
    DyTable,
  },
  mounted() {
    that = this;
    that.allCategory();
    that.getCourseList();
  },
  methods: {
    // changeSort(e) {
    //   console.log(e);
    //   that.currentPage = 1;
    //   switch (parseInt(e)) {
    //     case 1: //资源
    //       that.columns = [
    //         {
    //           key: 'textName',
    //           title: '资源名称',
    //         },
    //         {
    //           key: 'bgUserName',
    //           title: '操作人',
    //         },
    //         {
    //           key: 'updateDate',
    //           title: '最后更新时间',
    //         },
    //       ];
    //       that.getCourseList();
    //       break;
    //     case 2: //题库
    //       that.columns = [
    //         {
    //           key: 'textName',
    //           title: '题库名称',
    //         },
    //         {
    //           key: 'bgUserName',
    //           title: '操作人',
    //         },
    //         {
    //           key: 'updateDate',
    //           title: '最后更新时间',
    //         },
    //       ];
    //       that.getList4class();
    //       break;
    //   }
    // },
    //节点拖动
    handleDragEnd(draggingNode, dropNode) {
      console.log('节点拖动', draggingNode.label, dropNode.label);
      that.saveClassification(draggingNode.data.value, draggingNode.data.label, dropNode.data.value);
    },
    //节点点击
    getNodeIds(id) {
      console.log(id);
      that.categoryId = id;
      that.getCourseList();
      // that.changeSort(parseInt(that.sortVal));
    },
    //切换页面
    onCurrentChange(val) {
      that.currentPage = val;
      that.getCourseList();
      // switch (parseInt(that.sortVal)) {
      //   case 1: //课程
      //     that.getCourseList();
      //     break;
      //   case 2: //课文
      //     that.getList4class();
      //     break;
      // }
    },
    // 创建标签
    createTagEvent(obj) {
      that.saveClassification(obj.id, obj.name, obj.parentId);
    },
    //删除标签
    delLabel(id) {
      console.log('删除标签', id);
      that
        .$confirm('确认要删除此标签吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          let info = {
            id, //分类id
            type: 1,
          };
          var data = encrypt(JSON.stringify(info));
          zgDeleteCategory(data).then((res) => {
            if (res.result == 1) {
              that.$message({
                showClose: true,
                message: '删除成功',
                type: 'success',
              });
              that.allCategory();
            } else {
              this.$message({
                message: res.msg,
                type: 'warning',
              });
            }
          });
        });
    },
    // 添加/修改文章分类
    saveClassification(id, name, parentId) {
      console.log('before', id, name, parentId);
      parentId = id == parentId ? 0 : parentId;
      let info = {
        id, //分类id
        name, //分类名称
        parentId, //父节点ID
        type: 1,
      };
      var data = encrypt(JSON.stringify(info));
      zgAddCategory(data).then((res) => {
        if (res.result == 1) {
          that.$refs.sortLabel.closeDialog();
          that.$message({
            showClose: true,
            message: '添加成功',
            type: 'success',
          });
          that.allCategory();
        } else {
          that.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
    //获取课程列表
    getCourseList() {
      let info = {
        page: that.currentPage,
        pageSize: that.pageSize,
        categoryId: that.categoryId || '',
      };
      console.log(info);
      var data = encrypt(JSON.stringify(info));
      selectListResource(data).then((res) => {
        if (res.result == 1) {
          var ress = JSON.parse(decrypt(res.data));
          console.log('获取课程列表', ress);
          that.tableData = ress.list.map((item) => {
            return {
              ...item,
              textName: item.name,
            };
          });
          that.total = ress.total;
          that.tableLoading = false;
        } else {
          that.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
    //获取课文列表
    getList4class() {
      let info = {
        page: that.currentPage,
        pageSize: that.pageSize,
        categoryId: that.categoryId || '',
      };
      console.log(info);
      var data = encrypt(JSON.stringify(info));
      listQuestion(data).then((res) => {
        if (res.result == 1) {
          var ress = JSON.parse(decrypt(res.data));
          console.log('获取课文列表', ress);
          that.tableData = ress.list.map((item) => {
            return {
              ...item,
              textName: item.stem,
              updateDate: formatDate(new Date(item.createtime), 'yyyy-MM-dd hh:mm:ss'),
            };
          });
          that.total = ress.total;
          that.tableLoading = false;
        } else {
          that.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
    //获取所有分类(树型结构)
    allCategory() {
      let info = {
        type: 1,
      };
      var data = encrypt(JSON.stringify(info));
      zgsourceAllCategory(data).then((res) => {
        if (res.result == 1) {
          var ress = JSON.parse(decrypt(res.data));
          console.log('获取所有分类', ress);
          if (ress.length > 0) {
            const list = [{ name: '所有资源', id: '' }, ...ress];
            that.treeList = that.listFor(list);
            that.currentPage = 1;
            // that.categoryId = that.treeList[0].value;
            // switch (parseInt(that.sortVal)) {
            //   case 1: //课程
            //     that.getCourseList();
            //     break;
            //   case 2: //课文
            //     that.getList4class();
            //     break;
            // }
          }
          that.tableLoading = false;
        } else {
          that.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
    listFor(arr) {
      let children = [];
      if (arr != null && arr != '' && arr != undefined) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].childCourseCategory != '' && arr[i].childCourseCategory != null && arr[i].childCourseCategory != undefined) {
            children.push({
              value: arr[i].id,
              label: arr[i].name,
              children: this.listFor(arr[i].childCourseCategory),
            });
          } else {
            children.push({
              value: arr[i].id,
              label: arr[i].name,
              children: this.listFor(arr[i].childCourseCategory),
            });
          }
        }
      } else {
        return;
      }
      return children;
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  padding: 17px;

  .main-right {
    flex: 1;
    overflow: hidden;
    margin-left: 16px;
    padding: 24px;
    overflow-y: scroll;
    margin-top: 12px;
  }
}
</style>
